import {Component, Input, OnInit} from '@angular/core';
import {SummaryOption} from '../../back-office/Models/SummaryOption';

@Component({
  selector: 'tr[app-summary-box-option]',
  templateUrl: './summary-box-option.component.html',
  styleUrls: ['./summary-box-option.component.scss']
})
export class SummaryBoxOptionComponent implements OnInit {
  @Input() summaryOption: SummaryOption;
  @Input() customerPrice;
  @Input() showPrice;
  constructor() { }

  ngOnInit() {
  }

}
